import { applyMiddleware, legacy_createStore as createStore, Middleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createLogger } from 'redux-logger';
import createSaga from 'redux-saga';
import { persistStore } from 'redux-persist';

import reducer, { RootSaga } from './modules';

const loggerMiddleware = createLogger();
const sagaMiddleware = createSaga();

const middlewares: Middleware[] = [sagaMiddleware];
if (process.env.NODE_ENV === 'development') {
  middlewares.push(loggerMiddleware);
}
const middlewareEnhancer = applyMiddleware(...middlewares);
const enhancers = [middlewareEnhancer];
const composedEnhancers = composeWithDevTools(...enhancers);

export const store = createStore(reducer, composedEnhancers);
sagaMiddleware.run(RootSaga);

export const persistor = persistStore(store);

export default { store, persistor };
